.container {
  background-color: $c-neutral-06;
}

.item {
  padding-top: $space-02;
  padding-bottom: $space-02;

  @include agl-ds-screen-size('medium') {
    padding-top: $space-03;
    padding-bottom: $space-03;
  }

  @include agl-ds-screen-size('large') {
    padding-top: $space-03;
    padding-bottom: $space-03;
  }
}
